module.exports = __webpack_public_path__ + "img/11-2.1338420e.jpg";